import { modeloPlanilhaBeneficiariosXlsx } from '@ibk/shared-assets';
import { downloadFile } from '@ibk/shared-utils';
import { TEMPLATE_FILE_NAME } from '../types';
export async function generateTemplate() {
    const response = await fetch(modeloPlanilhaBeneficiariosXlsx);
    const arrayBuffer = await response.arrayBuffer();
    downloadFile(TEMPLATE_FILE_NAME, 'xlsx', [new Uint8Array(arrayBuffer)]);
}
